
import React, { Component } from 'react';
import { connect } from 'react-redux';
import assign from 'lodash/assign';
import get from 'lodash/get';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { sagas as sagasMap } from '../../map';
import { sagas as sagasMultiScene } from '../../multiscene';
import { sagas as sagasMeasurement } from '../../measurement';
import appGetActions from '../../app/saga';
import { getMapLayers } from '../../project';
import { MultiScene, componentDidUpdateInitViewFromUrl } from '../../multiscene';
import TabPanelsViewer from './TabPanelsViewer';
import getAppModules from './getAppModules';
import DialogObjectInfo from './DialogObjectInfo';

/**
 * Viewer containing 3D scene window and panel with tools.
 *
 * @reactProps {Object} projectDefinition - project definition
 * @reactProps {Object} appLayoutProps - properties for customize layout
 * @reactProps {Object} map - actual map state
 */
class MultiSceneViewer extends Component {

    classNames = mergeStyleSets({
        multiScene: {
        },
        divider: {
            borderLeft: '1px solid #cccccc'
        }
    });

    constructor(props) {
        super(props);
        this._multiSceneComponent = null;
    }

    componentDidUpdate(prevProps) {
        componentDidUpdateInitViewFromUrl(
            this._multiSceneComponent, this.props, prevProps
        );
    }

    getAppModules() {
        return getAppModules(this.props.projectDefinition);
    }

    getLayout() {
        let layout = get(this.props, 'projectDefinition.app.layout', null);
        if (!layout) {
            layout = get(this.props, 'layout', {});
        }
        assign(layout, this.props.appLayoutProps);
        return layout;
    }

    getLayoutValue(name, defaultValue) {
        let layout = this.getLayout();
        return get(layout, name, defaultValue);
    }

    getLayoutValues() {
        return {
            layersPanelPosition: this.getLayoutValue('layersPanelPosition', 'left'),
            tabPanelsWidth: this.getLayoutValue('tabPanelsWidth', null)
        }
    }

    handleObjectInfo = async (layerId, attributes) => {
        await DialogObjectInfo.show(
            getMapLayers(this.props.project),
            layerId,
            attributes,
            this.props.projectDefinition.app
        );
    }

    render() {
        return (
            <Stack horizontal styles={{root: {height: '100%'}}} tokens={{childrenGap: 0, padding: 5}}>
                {this.renderContent(this.getLayoutValues())}
            </Stack>
        );
}

    renderContent(layoutValues) {
        let tabPanelsComponent = this.renderTabPanels(layoutValues);
        let multiScene = this.renderMultiScene(layoutValues);
        let leftComponent = tabPanelsComponent;
        let rightComponent = multiScene;
        if (layoutValues['layersPanelPosition'] === 'right') {
            leftComponent = multiScene;
            rightComponent = tabPanelsComponent;
        }
        return (
            <React.Fragment>
                {leftComponent}
                <Stack.Item className={this.classNames.divider}>
                    <div></div>
                </Stack.Item>
                {rightComponent}
            </React.Fragment>
        );
    }

    renderTabPanels(layoutValues) {
        return (
            <Stack.Item>
                <TabPanelsViewer
                    uiValues={this.props.uiValues}
                    map={this.props.map}
                    layoutValues={layoutValues}
                    onlyOverLayers={true}
                    availablePanels={['data', 'layer', 'measurement', 'print', 'user']}
                    appModules={this.getAppModules()}
                    appActions={this.props.appActions}
                    appConfig={this.props.projectDefinition.app}
                    mapActions={this.props.mapActions}
                    measurementActions={this.props.measurementActions}
                    onObjectInfo={this.handleObjectInfo}
                />
            </Stack.Item>
        );
    }

    renderMultiScene(layoutValues) {
        return (
            <Stack.Item grow={1} className={this.classNames.multiScene}>
                <MultiScene
                    ref={element => this._multiSceneComponent = element}
                    appConfig={this.props.projectDefinition.app}
                    projectUrl={this.props.projectDefinition.multiSceneProject.url}
                    initialized={this.props.multiScene.initialized}
                    mode={this.props.multiScene.mode}
                    initialMode="points"
                    commands={this.props.multiScene.commands}
                    layers={this.props.map.layers}
                    appActions={this.props.appActions}
                    multiSceneActions={this.props.multiSceneActions}
                    measurementActions={this.props.measurementActions}
                    showHomeScene={true}
                    onObjectInfo={this.handleObjectInfo}
                />
            </Stack.Item>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        mapActions: sagasMap.getActions(dispatch),
        multiSceneActions: sagasMultiScene.getActions(dispatch),
        measurementActions: sagasMeasurement.getActions(dispatch),
        appActions: appGetActions(dispatch)
    };
}

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        auth: state.auth,
        uiValues: state.app.uiValues,
        urlParams: state.app.urlParams,
        multiScene: state.multiScene.multiScene,
        measurement: state.measurement,
        project: state.project
    };
}

const ConnectedMultiSceneViewer = connect(mapStateToProps, mapDispatchToProps)(MultiSceneViewer);

export default ConnectedMultiSceneViewer;
